<template>
  <v-row>
    <v-col md="8" sm="12">
      <v-card>
        <v-img class="white--text align-end" :src="article.image.full_hd">
        </v-img>
        <br />
        <v-card-text>
          <v-row align="center" class="mx-0">
            <v-avatar size="48">
              <v-img
                v-if="Object.keys(article.author_image).length"
                :src="article.author_image.thumbnail"
              ></v-img>
              <v-icon v-else color="primary">
                {{ icons.mdiAccountCircle }}
              </v-icon>
            </v-avatar>

            <div class="grey--text ml-4">
              {{ article.author }} <br />{{ getDate(article.release_date) }}
            </div>
          </v-row>
        </v-card-text>
        <v-card-title>
          <h3>{{ article.title }}</h3>
        </v-card-title>
        <v-card-text class="text--primary mb-0 pb-0">
          <div v-html="markdownToHtml(article.text)"></div>
          <br /><br />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import api from "@/api";
import useAuth from "@/useAuth";
import { getDate } from "@/@core/utils/datetime_helpers";
import useMarkdown from "@/@core/utils/useMarkdown";
import { mdiAccountCircle } from "@mdi/js";

export default {
  props: ["id"],
  setup(props) {
    const article = ref({});
    const { t } = useTranslations();
    const { markdownToHtml } = useMarkdown();

    // fetch data
    const fetchArticle = async (id) => {
      const response = await api.getPiiriArticle(id);

      article.value = response.data;
    };

    onMounted(() => {
      if (props.id) fetchArticle(props.id);
    });

    return {
      article,
      markdownToHtml,
      t,
      getDate,
      getDate,
      icons: {
        mdiAccountCircle,
      },
    };
  },
};
</script>

<style>
</style>